import { render, staticRenderFns } from "./offboardingDetails.vue?vue&type=template&id=d1377a98"
import script from "./offboardingDetails.vue?vue&type=script&lang=js"
export * from "./offboardingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports